/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import BomListWebApi from '../webapi/BomListWebApi';

export default {
    bomList: (name, query) => RemoteDataActions.list(name, undefined, query, BomListWebApi.bomList)
};
                                                                                                   


// WEBPACK FOOTER //
// ./js/actions/BomListActions.js